import { render, staticRenderFns } from "./OrdersSheet.vue?vue&type=template&id=a324ec06&scoped=true"
import script from "./OrdersSheet.vue?vue&type=script&lang=js"
export * from "./OrdersSheet.vue?vue&type=script&lang=js"
import style0 from "./OrdersSheet.vue?vue&type=style&index=0&id=a324ec06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a324ec06",
  null
  
)

export default component.exports